// Subject and body are separate rule fields; loading one into the other overwrote emailtext on save.
export const ruleMessageFields = (rule: {
  emailsubject: string;
  emailtext: string;
  smstext: string;
}) => ({
  email_subject: rule.emailsubject,
  email_message: rule.emailtext,
  sms_message: rule.smstext,
});
